import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./../Styles/cart.css";

export default function WishlistPage() {
  useEffect(() => {
    document.title = "WishList";
  }, []);
  const [wishlist, setWishlist] = useState([]);
  const [selected, setSelected] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.user_login_id || user?.id;

  /* ================= FETCH ================= */
  const fetchWishlist = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/Getwishlist?user_id=${userId}`,
      );

      const json = await res.json();

      let parsed = json;
      if (json.d) {
        parsed = typeof json.d === "string" ? JSON.parse(json.d) : json.d;
      }

      setWishlist(parsed?.data || []);
      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) fetchWishlist();
  }, []);

  /* ================= SELECT ================= */
  const toggleSelect = (cartId) => {
    setSelected((prev) => ({
      ...prev,
      [cartId]: !prev[cartId],
    }));
  };

  const toggleAll = (e) => {
    const checked = e.target.checked;
    const newSelected = {};

    wishlist.forEach((item) => {
      newSelected[item.cart_id] = checked;
    });

    setSelected(newSelected);
  };

  /* ================= REMOVE ================= */
  const removeItem = async (cartId) => {
    try {
      await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/RemoveWishlistDesign?cart_id=${cartId}&user_id=${userId}`,
      );

      setWishlist((prev) => prev.filter((item) => item.cart_id !== cartId));
      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (err) {
      console.error(err);
    }
  };

  const removeAll = async () => {
    if (!window.confirm("Remove all items?")) return;

    try {
      await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/ClearWishlist?user_id=${userId}`,
      );

      setWishlist([]);
      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= MOVE ================= */
  const moveToCart = async (item) => {
    try {
      await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/MovetoCart?user_id=${userId}&cart_id=${item.cart_id}`,
      );

      setWishlist((prev) => prev.filter((i) => i.cart_id !== item.cart_id));
      window.dispatchEvent(new Event("wishlistUpdated"));
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
    }
  };

  const moveSelectedToCart = async () => {
    const selectedItems = wishlist.filter((item) => selected[item.cart_id]);

    if (selectedItems.length === 0) {
      alert("Please select at least one design");
      return;
    }

    try {
      await Promise.all(
        selectedItems.map((item) =>
          fetch(
            `https://lifetimedesign.in/LtcJsonAPI.asmx/MovetoCart?user_id=${userId}&cart_id=${item.cart_id}`,
          ),
        ),
      );

      setWishlist((prev) => prev.filter((item) => !selected[item.cart_id]));
      window.dispatchEvent(new Event("wishlistUpdated"));
      window.dispatchEvent(new Event("cartUpdated"));

      setSelected({});

      alert("Selected designs moved to cart");
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= TOTAL ================= */
  const total = wishlist.reduce(
    (sum, item) => sum + Number(item.price || 0),
    0,
  );

  if (loading) return <div>Loading...</div>;
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "Wishlist",
      link: "/wishList",
    },
  ];
  /* ================= UI ================= */
  return (
    <div className="wish-page container-fluid">
      <div className="row">
        <div className="container-fluid">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {breadcrumbItems.map((item, i) => (
                <li
                  key={i}
                  className={`breadcrumb-item ${i === breadcrumbItems.length - 1 ? "active" : ""}`}
                >
                  {i === breadcrumbItems.length - 1 ? (
                    item.label
                  ) : (
                    <a href={item.link}>{item.label}</a>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </div>
        <div className="col-lg-12">
          {/* HEADER */}
          <div className="cart-header">
            <div className="cart-left">
              <input
                className="cl-check"
                type="checkbox"
                onChange={toggleAll}
              />
              <span>No</span>
              <span>Wishlist ({wishlist.length})</span>
            </div>

            <div className="cart-right">
              <span>Total Rs. {total}</span>

              <button className="remove-all" onClick={removeAll}>
                REMOVE ALL
              </button>

              <button className="wl-btn-danger" onClick={moveSelectedToCart}>
                MOVE TO CART
              </button>
            </div>
          </div>

          {/* ITEMS */}
          <div className="cart-grid">
            {wishlist.map((item, index) => (
              <div className="wish-item" key={item.cart_id}>
                <div className="item-no">
                  <input
                    className="cl-check"
                    type="checkbox"
                    checked={!!selected[item.cart_id]}
                    onChange={() => toggleSelect(item.cart_id)}
                  />
                  {index + 1}
                </div>
                <div
                  className="cart-img-box"
                  onMouseMove={(e) => {
                    const box = e.currentTarget;
                    const img = box.querySelector(".cart-img");
                    const zoom = box.querySelector(".zoom-preview");

                    const rect = box.getBoundingClientRect();

                    const mouseX = e.clientX - rect.left;
                    const mouseY = e.clientY - rect.top;

                    // move square with cursor
                    zoom.style.left = `${mouseX - 50}px`;
                    zoom.style.top = `${mouseY - 50}px`;

                    // show zoomed part exactly under cursor
                    zoom.style.backgroundImage = `url(${img.src})`;

                    zoom.style.backgroundSize = `${rect.width * 2}px ${rect.height * 2}px`;

                    zoom.style.backgroundPosition = `${-mouseX * 2 + 0}px ${-mouseY * 2 + 50}px`;

                    zoom.style.display = "block";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.querySelector(
                      ".zoom-preview",
                    ).style.display = "none";
                  }}
                  onClick={() =>
                    navigate(`/product?code=${item.code}&icid=${item.icid}`)
                  }
                >
                  <img
                    src={`https://lifetimedesign.in/controlpanel/Designs/${item.image_url}`}
                    className="cart-img"
                    alt={item.code}
                  />

                  <div className="zoom-preview"></div>
                </div>
                {/* <div className="cart-img-box">
                  <img
                    src={`https://lifetimedesign.in/controlpanel/Designs/${item.image_url}`}
                    className="cart-img"
                    alt=""
                  />
                </div> */}

                <div className="cart-details">
                  <p>
                    <strong>Code :</strong> {item.code}
                  </p>

                  <p>
                    <strong>Area :</strong> {item.area}
                  </p>
                  <p>
                    <strong>Height :</strong> {item.packageno}
                  </p>
                  <p>
                    <strong>Concept :</strong> {item.concept}
                  </p>
                </div>

                <div className="cart-details">
                  <p>
                    <strong>Stiches :</strong> {item.stiches}
                  </p>
                  <p>
                    <strong>Colour :</strong> {item.color}
                  </p>
                  <p>
                    <strong>Width :</strong> {item.sequence}
                  </p>
                  <p>
                    <strong>Detail : </strong>
                    {item.description}
                  </p>
                </div>
                <div className="cart-price">Rs. {item.price || 0}</div>

                {/* ACTIONS */}
                <div className="wl-item-actions1">
                  <button
                    className="wl-btn-view-sm"
                    onClick={() =>
                      navigate(`/product?code=${item.code}&icid=${item.icid}`)
                    }
                  >
                    VIEW
                  </button>

                  <button
                    className="wl-btn-gray-sm"
                    onClick={() => moveToCart(item)}
                  >
                    MOVE TO CART
                  </button>

                  <button
                    className="remove-all"
                    onClick={() => removeItem(item.cart_id)}
                  >
                    REMOVE
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
